export default __webpack_public_path__ + "static/media/two-dots.9ede45e4.svg";